import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { NguCarousel, NguCarouselConfig, NguCarouselStore } from '@ngu/carousel';
import { DevicesPlacementsV3Component } from '../devices-placements-v3/devices-placements-v3.component';
import { AnalyticsService } from '../../../analytics/services/analytics.service';

@Component({
	selector: 'app-placements-v4',
	templateUrl: './placements-v4.component.html',
	styleUrls: ['./placements-v4.component.css']
})
export class PlacementsV4Component extends DevicesPlacementsV3Component implements OnInit, OnDestroy {
	@Input() sectiontitle: string;
	@Input() key: string;
	@Input() datatableconfig;
	@Input() devicedatatableconfig: string;
	@Input() tertiarykey: string;

	constructor(protected analyticsService: AnalyticsService) {
		super(analyticsService);
	}

	ngOnInit() {
		super.ngOnInit();
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}
}
